import { createFileRoute } from "@tanstack/react-router";
import { ShareLinkPage } from "@/features/publicinfo/ShareLinkPage";

/** Public share page for one shared file or folder. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/share/$token")({
  component: ShareRoute,
});

function ShareRoute() {
  const { token } = Route.useParams();
  return <ShareLinkPage token={token} />;
}
